import Flex from '@Resources/styles/flex.scss';
import FolderIcon from '@mui/icons-material/FolderOutlined';
import { TableCell, TableRow } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './MapComponents.scss';

const EntitySelectionPopupOption = (props) => {
    const { folderName, onClick } = props;

    return (
        <TableRow onClick={onClick}>
            <TableCell className={Styles.espOption}>
                <div className={cx(Flex.flex, Flex.alignItemsCenter)}>
                    <FolderIcon style={{ fontSize: '.7rem' }} />
                    <span className={Styles.espOptionLbl}>{folderName}</span>
                </div>
            </TableCell>
        </TableRow>
    );
};

EntitySelectionPopupOption.propTypes = {
    folderName: PropTypes.string,
    onClick: PropTypes.func,
};
export default EntitySelectionPopupOption;
